<template lang="pug">
  .prestataire.fill-height
    v-card.elevation-0.fill-height
      v-layout.column.fill-height.justify-space-between.pb-2
        v-card-text
          v-form(v-if="client" v-model="valid" ref="clientForm")
            v-layout.clientInfo.wrap
              v-flex.xs12
                v-layout.justify-center
                  rc-uploader(
                    :url="client.has_image ? `/v2/erp/ambassador/clients/${client.id}/image/medium?t=${client.write_date}`: null"
                    @upload="uploadAvatar"
                    @error="uploadError"
                    @remove="removeAvatar"
                    fallbackIcon="store"
                    tile
                  )
              v-flex.xs12
                v-layout.column
                  v-flex
                    v-text-field.mt-3.title(
                      data-test="client-name-field"
                      :value="client.name"
                      @input="editClient('name', $event)"
                      full-width
                      label="Raison sociale"
                    )
                  v-flex
                    v-text-field(
                      data-test="client-siret-field"
                      :value="client.siret"
                      @input="editClient('siret', $event)"
                      :rules="[rules.siret]"
                      full-width
                      label="N° de SIRET"
                    )
              v-flex.xs12.px-2.mx-1(v-if="(context === 'create' || context === 'add')")
                rc-client-type-selector(
                  :selectedIds="client.type_ids"
                  :watch="typesWatch"
                  @change="vals => editClient('type_ids', vals)"
                )
                //- v-combobox(
                  data-test="client-type-field"
                  ref="ambassador_type_select"
                  label="Type du compte"
                  item-text="display_name"
                  :items="[{ header: 'Choisissez les types du compte ou ajoutez-en un' }, ...authorizedAmbassadorConfigs]"
                  :rules="[v => !!v || 'Vous devez choisir au moins un type de compte']"
                  multiple
                  chips
                  @change="editType"
                  @blur="$refs.ambassador_type_select.isFocused = false; $refs.ambassador_type_select.isMenuActive = false;"
                  )
              v-flex.xs12.px-2.mx-1(v-else-if="client.type_ids")
                rc-client-type-selector(
                  :selectedIds="client.type_ids"
                  @change="vals => editClient('type_ids', vals)"
                )
                //- v-combobox(
                //-   data-test="client-type-field"
                //-   ref="ambassador_type_select"
                //-   label="Type du compte"
                //-   item-text="display_name"
                //-   :items="[{ header: 'Choisissez les types du compte ou ajoutez-en un' }, ...authorizedAmbassadorConfigs]"
                //-   :value="authorizedAmbassadorConfigs.filter(it => client.type_ids.includes(it.id))"
                //-   :rules="[v => !!v || 'Vous devez choisir au moins un type de compte']"
                //-   multiple
                //-   chips
                //-   @change="editType"
                //-   @blur="$refs.ambassador_type_select.isFocused = false; $refs.ambassador_type_select.isMenuActive = false;"
                //- )
            .clientDetails
            .detail
              v-text-field.align-center.mt-3(
                data-test="client-phone-field"
                :value="client.phone"
                @input="editClient('phone', $event)"
                prepend-icon="phone"
                full-width
                label="Télephone"
                :rules="[rules.phone]"
              )
            .detail
              v-text-field.align-center.mt-3(
                data-test="client-email-field"
                :value="client.email"
                @input="editClient('email', $event)"
                prepend-icon="mail"
                full-width
                label="Email"
                :rules="[rules.email]"
              )
            .detail
              v-layout.row.wrap
                v-flex.xs6
                  v-text-field.align-center.mt-3(
                    data-test="client-city-field"
                    :value="client.city"
                    @input="editClient('city', $event)"
                    prepend-icon="place"
                    full-width
                    label="Ville"
                  )
                v-flex.xs4
                  v-text-field.align-center.mt-3(
                    data-test="client-zip-field"
                    :value="client.zip"
                    @input="editClient('zip', $event)"
                    full-width
                    label="Code postal"
                    :rules="[rules.zipcode]"
                  )
                v-flex.xs6
                  v-autocomplete.mt-3(
                    data-test="client-country-field"
                    ref="countrySelect"
                    :items="countries"
                    prepend-icon="place"
                    label="Pays"
                    item-text="name"
                    item-value="id"
                    return-object
                    :value="client.country_id || '72'"
                    @input=`editClient('country_id', $event.id);
                      editClient('country_code', $event.code);`
                    @blur="$refs.countrySelect.isFocused = false; $refs.countrySelect.isMenuActive = false;"
                  )
            .subheading.mt-4(v-if="client.destination_names && client.destination_names.filter(x => !!x).length && this.$store.state.app.destination.id === 1") Destination(s) de rattachement :
              .body-1.py-1.pl-3(v-for="destination_name in client.destination_names.filter(x => !!x)" :key="destination_name") - {{ destination_name.toUpperCase() }}
            rc-custom-fields.mt-4(
              v-if="client.id" type="touristic_provider" :entityId="client.id"
              @loading="value => { $emit('loading', value); }"
              ref="customFields"
            )
        v-card-actions
          v-layout(row justify-end)
          v-btn.error(@click="close" v-if="context === 'add'") Annuler
          v-btn.success(@click="create" v-if="context === 'add'" data-test="create-client-confirm") Valider
          slot(name="appendActions")
    v-dialog(v-model="dialog" width="30%")
      v-card
        v-card-title.headline Upload d'image impossible
        v-card-text L'image est trop grande
        v-card-actions
          v-spacer
          v-btn(color="primary" flat @click="dialog=false") Fermer
</template>

<script>
import RcUploader from '@/components/RcUploader/RcUploader.vue';
import RcCustomFields from '@/components/RcClients/RcCustomFields.vue'
import RcClientTypeSelector from '@/components/RcClientTypeSelector.vue'
import rcDebounce from '@/mixins/rcDebounce';
import axios from 'axios';
import apiClientService from '@/services/api/ambassador/clientService';
import apiTypeService from '@/services/api/common/typeService';

export default {
  components: {
    RcUploader,
    RcCustomFields,
    RcClientTypeSelector,
  },
  mixins: [
    rcDebounce,
  ],
  props: {
    context: {
      type: String,
      default: 'modify',
    },
    title: {
      type: String,
      default: 'COMPTE',
    },
  },
  data() {
    return {
      valid: true,
      dialog: false,
      title_picture: 'Image Upload',
      uploaderErrorMessage: '',
      imageName: '',
      imageUrl: '',
      imageFile: '',
      transientFile: null,
      rules: {
        phone: v => /((((\+33)|0))\s?(\(0\))?\d(\s|-|\.)?(\d{2}(\s|-|\.)?){4})|^$/.test(v) || v === null || v === undefined || 'Télephone invalide',
        siret: v => /(^\d{3}\s?\d{3}\s?\d{3}\s?\d{5}$)|^$/.test(v) || v === null || v === undefined || 'Numéro de SIRET invalide',
        email: v => /(^[-.a-zA-Z0-9_]*(\.[-a-zA-Z0-9_]+)*@[-a-zA-Z0-9_]+(\.[-a-zA-Z0-9_]+)*\.[a-zA-Z]{2,4}$)|^$/.test(v) || v === null || v === undefined || 'Email invalide',
        // phone: v => /((\+\d+(\s|-|\.))?0\d(\s|-|\.)?(\d{2}(\s|-|\.)?){4})|^$/.test(v) || v === null || v === undefined || 'Télephone invalide',
        required: v => !!v || 'Champ obligatoire',
        zipcode: v => /(^[0-9]{5,5}$)|^$/.test(v) || v === null || v === undefined || 'Code postal invalide',
      },
      savePending: false,
      typesWatch: false,
    };
  },
  mounted() {
    if (['create', 'add'].includes(this.context)) {
      this.$store.dispatch('clients/setSelected', { country_id: 76 });
    }
  },
  destroyed() {
    this.$store.dispatch('clients/setSelected', null);
  },
  computed: {
    authorizedAmbassadorConfigs() {
      return this.$store.state.clients.types || [];
    },
    countries() {
      return this.$store.state.countries.countries;
    },
    loaded() {
      return ['customFields'].every(it => this.$refs[it] && this.$refs[it].loaded);
    },
    client() {
      return this.$store.state.clients.selectedClient;
    }
  },
  filters: {
    capitalize: function (value) {
      if (!value) return '';
      value = value.toString().toLowerCase();
      return value.charAt(0).toUpperCase() + value.slice(1);
    }
  },
  methods: {
    async editType(val) {
      const existingValues = val.filter(it => typeof it === 'object' && !!it);
      const newValue = val.find(it => typeof it === 'string');
      if (newValue) {
        const newType = await apiTypeService.addClientType(newValue);
        if (newType) {
          existingValues.push(newType);
        }
      }
      this.editClient('type_ids', existingValues.map(it => it.id))
    },
    editAmbassadorType(data) {
      axios.put(`/v2/erp/clients/${this.client.id}/configuration`, { ambassadorType: data ? data.id : null });
    },
    uploadError(e) {
      this.uploaderErrorMessage = e.code;
      this.dialog = true;
    },
    uploadAvatar(file) {
      if (this.context === 'modify') {
        apiClientService.uploadLogoById(this.client.id, file, file.type);
      } else {
        this.transientFile = file;
      }
    },
    removeAvatar() {
      if (this.context === 'modify') {
        apiClientService.deleteLogoById(this.client.id);
      } else {
        this.transientFile = null
      }
    },
    close() {
      this.$emit('close');
    },
    editClient(field, value) {
      this.$store.dispatch('clients/editClient', { field, value });
      this.typesWatch = ! this.typesWatch;
      if (this.context === 'modify') {
        this.savePending = true;
        this.rcDebounce(this.create, 200);
      }
    },
    async create() {
      if (this.$refs.clientForm && this.$refs.clientForm.validate()) {
        if (this.context === 'modify') {
          this.savePending = false;
          await apiClientService.put(this.client.id, this.$store.state.clients.selectedClient);
          this.$store.dispatch('clients/getSearchTypes');
        } else {
          const newClientId = await apiClientService.create(this.$store.state.clients.selectedClient);
          if (this.transientFile && newClientId) {
            await apiClientService.uploadLogoById(newClientId, this.transientFile, this.transientFile.type);
          }
          this.$store.dispatch('clients/getSearchTypes');
          this.$emit('close');
          this.$router.push({ name: 'client_prestataire_detail', params: { clientId: newClientId } });
        }
      }
    },
  },
  beforeDestroy() {
    if (this.$refs.clientForm && this.$refs.clientForm.validate() && this.savePending) {
      if (this.context === 'modify') {
        this.savePending = false;
        apiClientService.put(this.client.id, this.$store.state.clients.selectedClient);
      }
    }
  },
};
</script>

<style lang="scss">
.v-input--is-disabled {
  .v-input__slot {
    input {
      color: black;
    }
  }
}
.prestataire {
  .v-form {
    .v-text-field__details {
      margin: 0;
    }
    .v-text-field:not(.error--text) {
      .v-text-field__details {
        display: none;
      }
      .v-input__slot {
        margin: 0;
      }
    }
    .detail {
      .v-input.v-select {
        padding-top: 0px;
        .v-input__control {
          padding-left: 10px;
        }
      }
    }
  }
  .v-text-field__suffix {
    color: red;
  }
  .clientDetails {
    .v-text-field.v-text-field--full-width .v-input__control {
      padding-bottom: 5px;
    }
  }
  .clientInfo {
    .v-text-field.v-text-field--full-width .v-input__control {
      padding: 0px;
    }
  }
}
.image-box img {
  width: 40px;
  height: 40px;
}
.uploader-button {
  border-radius: 50%;
}
</style>
